import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initDcBanner() {
    const banner = document.querySelector('.dcBanner');
    if (!banner) return;

    const badge = banner.querySelector('.dcBanner__badge');
    const image = banner.querySelector('.dcBanner__image');

    gsap.fromTo(banner,
        { maxWidth: '80%' },
        {
            maxWidth: '2100px',
            ease: 'none',
            scrollTrigger: {
                trigger: banner,
                start: 'top bottom',
                end: 'top 30%',
                scrub: true,
            }
        }
    );

    if (image) {
        gsap.fromTo(image,
            { borderRadius: '40px' },
            {
                borderRadius: '0px',
                ease: 'none',
                scrollTrigger: {
                    trigger: banner,
                    start: 'top bottom',
                    end: 'top 30%',
                    scrub: true,
                }
            }
        );
    }

    if (badge) {
        gsap.fromTo(badge,
            { rotation: 7 },
            {
                rotation: -7,
                ease: 'none',
                scrollTrigger: {
                    trigger: banner,
                    start: 'top bottom',
                    end: 'top 30%',
                    scrub: true,
                }
            }
        );
    }

    ScrollTrigger.create({
        trigger: banner,
        start: 'top 10%',
        onEnter: () => banner.classList.add('is-ready'),
        onLeaveBack: () => banner.classList.remove('is-ready'),
    });

}